module.exports = __webpack_public_path__ + "img/icon_borad_off.6272a93e.svg";